export default __webpack_public_path__ + "static/media/LR.8ddad010.ico";